import React from 'react'
import { UploadSupplierFormBuyerStyle } from '../UploadSupplierFormContainer/styled.js'
import {
  Button,
  Image,
  InputUpload,
  Section,
  Spinner,
  Breadcrumbs,
} from '../../components'
import { ICONS } from '../../themes'
import { STRING } from '../../helpers'
import FileDownload from 'js-file-download'
import { regulatoryController } from '../../apiService'
import { toastActive } from '../../helpers/functions/toastSuccess'
import { toastFail } from '../../helpers/functions/toastFail'
import { pageUploadRegulatoryController } from '../../middleware'

export class UploadRegulatoryContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedFile: null,
      selectedFileplaceholder: null,
      uploadRegulatory: [],
      loadingFileInternal: false,
      checkRole: '',
    }
    this.renderUploadRegulatory = this.renderUploadRegulatory.bind(this)
  }
  componentDidMount() {
    const roles = pageUploadRegulatoryController().asset()
    this.setState({ checkRole: roles })
  }
  // On file select (from the pop up)
  onFileChange = event => {
    // Update the state
    this.setState({ selectedFile: event.target.files[0] })
    this.setState({ selectedFileplaceholder: event.target.files[0] })
  }

  _downloadSustainabilityLink() {
    return regulatoryController()
      .downloadRegulatory()
      .then(res => FileDownload(res.data, 'regulatory_form.xlsx'))
  }

  _fileUpload() {
    this.setState({ loadingFileInternal: true })
    if (this.state.selectedFile === null) {
      toastFail('Please browse your file')
      this.setState({ loadingFileInternal: false })
    } else {
      let formData = new FormData()
      formData.append('file', this.state.selectedFile)
      // console.log('formData', formData)
      return regulatoryController()
        .uploadRegulatory(formData)
        .then(res => {
          // console.log('_fileUpload', res)
          // this.setState({
          //   uploadRegulatory: res,
          //   loadingFileInternal: false,
          // })
          if (res) {
            if (res.status === 'UploadSuccess') {
              toastActive('Upload File Complete')
              this.setState({
                selectedFile: null,
                uploadRegulatory: res,
                loadingFileInternal: false,
                selectedFileplaceholder: null,
              })
              document.getElementById('upload').value = ''
            } else if (res.status === 'error') {
              toastFail('Please Check Your Error')
              this.setState({
                selectedFile: null,
                uploadRegulatory: res,
                loadingFileInternal: false,
                selectedFileplaceholder: null,
              })
              document.getElementById('upload').value = ''
            } else if (res.status === 'errorTemplate') {
              toastFail('Master data not match')
              this.setState({
                selectedFile: null,
                uploadRegulatory: [],
                loadingFileInternal: false,
                selectedFileplaceholder: null,
              })
              document.getElementById('upload').value = ''
            } else {
              toastFail(res.message)
              this.setState({
                selectedFile: null,
                uploadRegulatory: [],
                loadingFileInternal: false,
                selectedFileplaceholder: null,
              })
              document.getElementById('upload').value = ''
            }
          }
        })
        .catch(error => {
          this.setState({
            loadingFileInternal: false,
          })
        })
    }
  }
  renderUploadRegulatory = () => {
    const uploadRegulatoryData = this.state.uploadRegulatory || {}
    const renderPageTitle = () => {
      // const handlerClick = e => {
      //   return this.props.history.push(ROUTE_PATH.HOME.LINK)
      // }
      return (
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_sustainability_pre_assessment_management"
                src={ICONS['icon-compliance-white.svg']}
                alt="page icon"
              />
            </Section>
            <Section className="title-and-breadcrumb">
              <Section
                id="page_title_sustainability_pre_assessment_management"
                className="title"
              >
                {STRING.REGULATORY}
              </Section>
              <Breadcrumbs props={this.props} />
            </Section>
          </Section>
        </Section>
      )
    }
    const pageContent = () => {
      const handlerClickFileUpload = () => {
        return this._fileUpload()
      }
      const loadingFileUpload = () => {
        if (this.state.loadingFileInternal) {
          return <Spinner className="loading" />
        }
      }
      const downloadSustainability = e => {
        return this._downloadSustainabilityLink()
      }
      const uploadFileComplete = () => {
        if (uploadRegulatoryData.message === 'Upload File Complete') {
          return <span className="success">Upload File Complete</span>
        } else {
          if (uploadRegulatoryData.message) {
            return uploadRegulatoryData.message.map(item => {
              return (
                <span className="error" key={item.Row}>
                  <React.Fragment>
                    Row {item.Row}
                    {Array.isArray(item.InValid)
                      ? item.InValid.map(it => <div key={it}>{it},</div>)
                      : null}
                  </React.Fragment>
                </span>
              )
            })
          }
        }
      }
      return (
        <Section className="main-content form">
          <Section className="content-body">
            <Section className="form-wrapper">
              <Section className="form-group-title">
                {/* {STRING.SUSTAINABILITY}  */}
                Code of Practice
              </Section>
              <Section className="form-group upload-wrapper">
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    {this.state.checkRole && (
                      <>
                        <InputUpload
                          id="upload"
                          onChange={this.onFileChange}
                          selectedFileName={
                            this.state.selectedFile
                              ? this.state.selectedFile.name
                              : ''
                          }
                          placeholder={
                            this.state.selectedFileplaceholder
                              ? this.state.selectedFileplaceholder.name
                              : ''
                          }
                        />
                        <Button
                          className="theme-blue"
                          onClick={handlerClickFileUpload}
                        >
                          Upload
                        </Button>
                      </>
                    )}
                    {loadingFileUpload()}
                  </Section>
                </Section>
              </Section>
              {this.state.checkRole && (
                <a
                  href="#"
                  className="file-download-link"
                  onClick={downloadSustainability}
                >
                  Download Supplier Code of Practice
                </a>
              )}
              <Section className="form-group">
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <div className="upload-log-outter-wrapper">
                      <Section className="lists-wrapper">
                        <div className="upload-log-wrapper">
                          {uploadFileComplete()}
                        </div>
                      </Section>
                    </div>
                  </Section>
                </Section>
              </Section>
            </Section>
          </Section>
        </Section>
      )
    }
    return (
      <UploadSupplierFormBuyerStyle>
        {renderPageTitle()}
        {pageContent()}
      </UploadSupplierFormBuyerStyle>
    )
  }
  render = () => this.renderUploadRegulatory()
}
